module.exports = __webpack_public_path__ + "static/sustainable_bn@2x-c5cd71d7957567b58b8177cb28429fec.png";